import { Home, LogIn, Settings, User, UserPlus, Users } from "react-feather"
import { AdminUsersPage } from "@/pages/admin-users/AdminUsersPage"
import { IpRestrictedPage } from "@/pages/ip-restricted/IpRestrictedPage"
import { OrganizationIpRestrictionPage } from "@/pages/organizations/OrganizationIpRestrictionPage"
import { OrganizationsPage } from "@/pages/organizations/OrganizationsPage"
import { OwnerDetailPage } from "@/pages/owner/OwnerDetailPage"
import { OwnerPage } from "@/pages/owner/OwnerPage"
import { OperationRuleDetailPage } from "@/pages/owner/operation-rule/OperationRuleDetailPage"
import { PasswordIssuePage } from "@/pages/password-issue/PasswordIssuePage"
import { PasswordResetPage } from "@/pages/password-reset/PasswordResetPage"
import { PasswordChangePage } from "@/pages/profile/PasswordChangePage"
import { ProfilePage } from "@/pages/profile/ProfilePage"
import { PropertyAddPage } from "@/pages/property/add/PropertyAddPage"
import { PropertyEditPage } from "@/pages/property/edit/PropertyEditPage"
import { PropertyDetailPage } from "@/pages/property/PropertyDetailPage"
import { PropertyPage } from "@/pages/property/PropertyPage"
import { RoomAddPage } from "@/pages/property/rooms/add/RoomAddPage"
import { RoomEditPage } from "@/pages/property/rooms/edit/RoomEditPage"
import { RoomDetailPage } from "@/pages/property/rooms/RoomDetailPage"
import { RoomTenantAddPage } from "@/pages/property/rooms/RoomTenantAddPage"
import { RoomTenantEditPage } from "@/pages/property/rooms/RoomTenantEditPage"
import { RolesPage } from "@/pages/roles/RolesPage"
import { SigninPage } from "@/pages/signin/SigninPage"
import { TestIndexPage } from "@/pages/TestIndexPage"
import { TenantAddPage } from "@/pages/tenant/add/TenantAddPage"
import { TenantEditPage } from "@/pages/tenant/edit/TenantEditPage"
import { TenantDetailPage } from "@/pages/tenant/TenantDetailPage"
import { TenantPage } from "@/pages/tenant/TenantPage"
import { TenantApplicantDetailPage } from "@/pages/tenant-applicants/TenantApplicantDetailPage"
import { TenantApplicantsPage } from "@/pages/tenant-applicants/TenantApplicantsPage"
import { TicketAddPage } from "@/pages/ticket/add/TicketAddPage"
import { TicketEditPage } from "@/pages/ticket/edit/TicketEditPage"
import { TicketDetailPage } from "@/pages/ticket/TicketDetailPage"
import { TicketPage } from "@/pages/ticket/TicketPage"

export interface RouteInfo {
  name: string
  path: string
  external?: boolean
  component?: React.ComponentType
}

export interface RouteCategory {
  category: string
  // biome-ignore lint/suspicious/noExplicitAny: testing purposes
  icon: any
  routes: RouteInfo[]
}

// 開発用のルート
export const devRoutes: RouteCategory[] = [
  {
    category: "開発用",
    icon: Settings,
    routes: [
      {
        name: "ルート一覧",
        path: "/_list",
        component: TestIndexPage,
      },
    ],
  },
]

// 認証不要なページ
export const publicRoutes: RouteCategory[] = [
  {
    category: "認証",
    icon: LogIn,
    routes: [
      {
        name: "ログイン",
        path: "/login",
        component: SigninPage,
      },
      {
        name: "パスワード再設定リクエスト",
        path: "/password-issue",
        component: PasswordIssuePage,
      },
      {
        name: "パスワード再設定",
        path: "/password-reset",
        component: PasswordResetPage,
      },
      {
        name: "IPアドレス制限によるアクセス拒否",
        path: "/ip-restricted",
        component: IpRestrictedPage,
      },
    ],
  },
]

// 認証が必要なページ
export const protectedRoutes: RouteCategory[] = [
  {
    category: "物件管理",
    icon: Home,
    routes: [
      {
        name: "物件一覧",
        path: "/properties",
        component: PropertyPage,
      },
      {
        name: "物件詳細画面",
        path: "/properties/:propertyId",
        component: PropertyDetailPage,
      },
      {
        name: "物件新規登録画面",
        path: "/properties/add",
        component: PropertyAddPage,
      },
      {
        name: "物件編集画面",
        path: "/properties/:propertyId/edit",
        component: PropertyEditPage,
      },
      {
        name: "部屋詳細画面",
        path: "/properties/:propertyId/rooms/:roomId",
        component: RoomDetailPage,
      },
      {
        name: "部屋新規登録画面",
        path: "/properties/:propertyId/rooms/add",
        component: RoomAddPage,
      },
      {
        name: "部屋編集画面",
        path: "/properties/:propertyId/rooms/:roomId/edit",
        component: RoomEditPage,
      },
      {
        name: "賃借人情報編集",
        path: "/properties/:propertyId/rooms/:roomId/tenants/:tenantId/edit",
        component: RoomTenantEditPage,
      },
      {
        name: "賃借人新規追加",
        path: "/properties/:propertyId/rooms/:roomId/tenants/add",
        component: RoomTenantAddPage,
      },
    ],
  },
  {
    category: "賃借人管理",
    icon: Home,
    routes: [
      {
        name: "賃借人一覧",
        path: "/tenants",
        component: TenantPage,
      },
      {
        name: "賃借人詳細",
        path: "/tenants/:tenantId",
        component: TenantDetailPage,
      },
      {
        name: "賃借人新規登録",
        path: "/tenants/add",
        component: TenantAddPage,
      },
      {
        name: "賃借人編集画面",
        path: "/tenants/:tenantId/edit",
        component: TenantEditPage,
      },
    ],
  },
  {
    category: "案件管理",
    icon: Home,
    routes: [
      {
        name: "案件一覧",
        path: "/tickets",
        component: TicketPage,
      },
      {
        name: "案件詳細画面",
        path: "/tickets/:ticketId",
        component: TicketDetailPage,
      },
      {
        name: "案件新規登録画面",
        path: "/tickets/add",
        component: TicketAddPage,
      },
      {
        name: "案件編集画面",
        path: "/tickets/:ticketId/edit",
        component: TicketEditPage,
      },
    ],
  },
  {
    category: "新規入居者申込",
    icon: UserPlus,
    routes: [
      {
        name: "新規入居者申込一覧",
        path: "/tenant-applicants",
        component: TenantApplicantsPage,
      },
      {
        name: "新規入居者申込詳細",
        path: "/tenant-applicants/:applicantId",
        component: TenantApplicantDetailPage,
      },
    ],
  },
  {
    category: "オーナー管理",
    icon: Home,
    routes: [
      {
        name: "オーナー一覧",
        path: "/owners",
        component: OwnerPage,
      },
      {
        name: "オーナー詳細画面(API未連携)",
        path: "/owners/:ownerId",
        component: OwnerDetailPage,
      },
      {
        name: "運用ルール詳細",
        path: "/owners/:ownerId/operation-rules",
        component: OperationRuleDetailPage,
      },
    ],
  },
  {
    category: "管理ユーザー管理",
    icon: Users,
    routes: [
      {
        name: "管理ユーザー一覧",
        path: "/admin-users",
        component: AdminUsersPage,
      },
      {
        name: "ロール管理",
        path: "/roles",
        component: RolesPage,
      },
      {
        name: "組織管理",
        path: "/organizations",
        component: OrganizationsPage,
      },
      {
        name: "IPアドレス制限設定",
        path: "/organizations/:organizationId/ip-restriction",
        component: OrganizationIpRestrictionPage,
      },
    ],
  },
  {
    category: "プロフィール",
    icon: User,
    routes: [
      {
        name: "プロフィール設定",
        path: "/profile",
        component: ProfilePage,
      },
      {
        name: "パスワード変更",
        path: "/profile/password",
        component: PasswordChangePage,
      },
    ],
  },
]
